/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Managers/StatManager',['absolute/storagemanager'], function (StorageManager) {
    "use strict";

    var StatManager = {

        _stats: null,

        _key: "STATS",

        Init: function () {
            if (this._stats) {
                return;
            }

            if (!this._stats) {
                this._stats = StorageManager.fetch(this._key);
            }
            if (!this._stats) {
                this._stats = {};
            }
        },

        ValueExists: function (key) {
            this.Init();
            return this._stats[key] != undefined;
        },

        GetValue: function (key) {
            this.Init();
            return this._stats[key] || 0;
        },

        SetStatistic: function (key, value, forceLocal) {
            this._stats[key] = value;
        },

        Save: function () {
            StorageManager.store(this._key, this._stats);
        }
    };


    return StatManager;

});
